import { render } from "./StrategiesView.vue?vue&type=template&id=56b0536c&scoped=true"
import script from "./StrategiesView.vue?vue&type=script&lang=js"
export * from "./StrategiesView.vue?vue&type=script&lang=js"

import "./StrategiesView.vue?vue&type=style&index=0&id=56b0536c&lang=scss&scoped=true"

import exportComponent from "E:\\Source\\HuasCo\\personal-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b0536c"]])

export default __exports__